// extracted by mini-css-extract-plugin
export var currencyInput = "_nn-1";
export var currencySymbol = "_nn-0";